
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/news",
      function () {
        return require("private-next-pages/en/ir/news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/news"])
      });
    }
  